import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import './menu-item.css'

const MenuItem = ({ path, label, router, onClick, children }) => {
  const hasChildren = children && children.length > 0;

  if (label === 'Dashboard') {
    return (
      <li>
        <Link
          to={path}
          className={classnames("", { active: router.isActive(path) })}
          onClick={onClick}
        >
          Home
        </Link>
      </li>
    );
  }

  return (
    <li className={hasChildren ? "has-dropdown" : ""}>
      <Link
        to={path}
        className={classnames("", { active: router.isActive(path) })}
        onClick={(e) => {
          e.preventDefault();

          router.push(path);

          if (onClick) {
            onClick();
          }
        }}
      >
        {label}
        {hasChildren && <span className="menu-caret">▼</span>}
      </Link>

      {hasChildren && (
        <ul className="dropdown-menu">
          {children}
        </ul>
      )}
    </li>
  );
};

MenuItem.propTypes = {
  path: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  router: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  children: PropTypes.node
};

export default MenuItem;